export const GET_LIST_TICKET_ROOM_REQUEST = 'GET_LIST_TICKET_ROOM_REQUEST';
export const GET_LIST_TICKET_ROOM_SUCCESS = 'GET_LIST_TICKET_ROOM_SUCCESS';
export const ADD_CHAIR_SUCCESS = 'ADD_CHAIR_SUCCESS';
export const POST_BOOKING_TICKET_SUCCESS = 'POST_BOOKING_TICKET_SUCCESS';
export const POST_BOOKING_TICKET_FAILURE = 'POST_BOOKING_TICKET_REQUEST';
export const CREATE_FILM_SCHEDULE_SUCCESS = 'CREATE_FILM_SCHEDULE_SUCCESS'; 
